import React, { useEffect, useMemo, useState } from "react"
import { Button, Card, CardBody, Container, FormGroup, Input, Label } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import breadcrumbs from "common/Breadcrumbs"
import { useLocation, useNavigate } from "react-router-dom"
import ProductHistoryTable from "./ProductHistoryTable"
import { dateFormat } from "pages/Common"
import useApi from "common/ApiMiddlewere"
import { toast } from "react-hot-toast"
import uploadImage from "../../../assets/images/uploadImage.png"
import { routes } from "routes/path"
import GetObjectsByValues from "_mock/Static_data"
import { useSelector } from "react-redux"

function ProductHistory(props) {
  document.title = `Product History | ${localStorage.getItem("ShopName")}`
  let { pathname } = useLocation()
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const financeAmountShowHide = useSelector(state => state.ReduxData.finaceAmountShow);
  const productCode = params.get('productCode');
  const { postApi } = useApi()
  const navigate = useNavigate()
  const [tableData, settableData] = useState([])
  const [IsLoading, setIsLoading] = useState(false)
  const [searchText, setsearchText] = useState(productCode || '')
  const [pendingForReturn, setpendingForReturn] = useState(false)
  const [isAllData, setIsAllData] = useState(false)
  const [totalBooking, setTotalBooking] = useState(0)
  const [viewtotaliBooking, setViewTotalBooking] = useState(false)
  const [productDetails, setProductDetails] = useState()
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [totalEarned, setTotalEarned] = useState(0)

  useEffect(() => {
    if (productCode) {
      handleSearch()
    }
  }, [productCode])

  const handleSearch = () => {
    setIsLoading(true)
    if (searchText) {
      postApi("Report/product-history", {
        productCode: searchText.trim(),
        pendingForReturn,
        IsAllData: isAllData,
      }).then(({ data, status }) => {
        if (status === 200) {
          settableData(data.ProductHistoryList)
          setViewTotalBooking(true)
          setIsLoading(false)
          setTotalBooking(data.ProductHistoryList.length)
          setProductDetails(data)
          let Amount = 0
          data.ProductHistoryList.map((item, i) => {
            setTotalEarned(Amount += parseInt(item.Amount))
          })

        } else {
          setViewTotalBooking(false)
          setIsLoading(false)
          settableData([])
          setProductDetails()
          setTotalEarned(0)
          toast.error(data, {
            style: {
              fontSize: "15px",
            },
          })
        }
      })
    } else {
      setIsLoading(false)
      setViewTotalBooking(false)
      settableData([])
      setProductDetails()
      setTotalEarned(0)
      toast.error("search text is required", {
        style: {
          fontSize: "15px",
        },
      })
    }
  }

  useEffect(() => {
    if (searchText) {
      handleSearch()
    }
  }, [pendingForReturn, isAllData])

  const handleProductHistory = (productCode) => {
    if (productCode) {
      navigate(routes.productList, {
        state: {
          ProductCode: productCode,
        },
      })
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <div
            style={{
              textAlign: "left",
            }}
          >
            Bill No.
          </div>
        ),
        accessor: "BillNo",
        width: "5%",
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "left",
            }}
          >
            Code
          </div>
        ),
        accessor: "ProductCode",
        width: "5%",
        Cell: ({ row }) => {
          return <div>{productDetails?.ProductCode}</div>
        },
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "left",
            }}
          >
            Status
          </div>
        ),
        accessor: "Status",
        Cell: ({ row }) => {
          const status = GetObjectsByValues(row.original.Status);
          return <div>{status[0]?.DisplayName}</div>
        },
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "left",
            }}
          >
            Booking Date
          </div>
        ),
        accessor: "BookingDate",
        width: "7%",
        Cell: ({ row }) => {
          return <div>{dateFormat(row.original.BookingDate, "dd/MM/yyyy")}</div>
        },
      },
      {
        Header: "Delivery",
        accessor: "DeliveryDate,DeliveryTimeSlot",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original.DeliveryDate == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(
                row.original.DeliveryDate.split("T")[0],
                "dd/MM/yyyy"
              )}
            {row.original.DeliveryTimeSlot ? (
              <span> {` (${row.original.DeliveryTimeSlot})`}</span>
            ) : (
              ""
            )}
          </p>
        ),
      },
      {
        Header: "Return",
        accessor: "ReturnDate",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original.ReturnDate == null
              ? "N/A"
              : dateFormat(row.original.ReturnDate.split("T")[0], "dd/MM/yyyy")}
            {row.original.ReturnTimeSlot ? (
              <span> {` (${row.original.ReturnTimeSlot})`}</span>
            ) : (
              ""
            )}
          </p>
        ),
      },
      {
        Header: () => (
          <div style={{
            display: "flex",
            alignItems: "end",
            justifyContent: "end",
            textAlign: "end"
          }}
          >
            Amount
          </div>
        ),
        accessor: "Amount",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              textAlign: "end"
            }}
            >
              <i className="mdi mdi-currency-inr"></i>
              {new Intl.NumberFormat('en-IN', {
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(row?.original?.Amount || 0)}
            </div>
          )
        },
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "left",
            }}
          >
            Customer Name
          </div>
        ),
        accessor: "CustomerName",
        Cell: ({ row }) => {
          return <div>{row.original.CustomerName}</div>
        },
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "left",
            }}
          >
            Contact No.
          </div>
        ),
        width: "7%",
        accessor: "CustomerContactNo",
        Cell: ({ row }) => {
          return <div>{row.original.CustomerContactNo}</div>
        },
      },
    ],
    [tableData]
  )
  const columns1 = useMemo(
    () => [
      {
        Header: () => (
          <div
            style={{
              textAlign: "left",
            }}
          >
            Bill No.
          </div>
        ),
        accessor: "BillNo",
        width: "5%",
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "left",
            }}
          >
            Code
          </div>
        ),
        accessor: "ProductCode",
        width: "5%",
        Cell: ({ row }) => {
          return <div>{productDetails?.ProductCode}</div>
        },
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "left",
            }}
          >
            Status
          </div>
        ),
        accessor: "Status",
        Cell: ({ row }) => {
          const status = GetObjectsByValues(row.original.Status);
          return <div>{status[0]?.DisplayName}</div>
        },
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "left",
            }}
          >
            Booking Date
          </div>
        ),
        accessor: "BookingDate",
        width: "7%",
        Cell: ({ row }) => {
          return <div>{dateFormat(row.original.BookingDate, "dd/MM/yyyy")}</div>
        },
      },
      {
        Header: "Delivery",
        accessor: "DeliveryDate,DeliveryTimeSlot",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original.DeliveryDate == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(
                row.original.DeliveryDate.split("T")[0],
                "dd/MM/yyyy"
              )}
            {row.original.DeliveryTimeSlot ? (
              <span> {` (${row.original.DeliveryTimeSlot})`}</span>
            ) : (
              ""
            )}
          </p>
        ),
      },
      {
        Header: "Return",
        accessor: "ReturnDate",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original.ReturnDate == null
              ? "N/A"
              : dateFormat(row.original.ReturnDate.split("T")[0], "dd/MM/yyyy")}
            {row.original.ReturnTimeSlot ? (
              <span> {` (${row.original.ReturnTimeSlot})`}</span>
            ) : (
              ""
            )}
          </p>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "left",
            }}
          >
            Customer Name
          </div>
        ),
        accessor: "CustomerName",
        Cell: ({ row }) => {
          return <div>{row.original.CustomerName}</div>
        },
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "left",
            }}
          >
            Contact No.
          </div>
        ),
        width: "7%",
        accessor: "CustomerContactNo",
        Cell: ({ row }) => {
          return <div>{row.original.CustomerContactNo}</div>
        },
      },
    ],
    [tableData]
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={breadcrumbs[pathname].title}
            breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
          />
          <Card>
            <CardBody>
              <div className="row mb-3">
                <div className="col-md-3">
                  <input
                    onChange={e => {
                      setsearchText(e.target.value)
                    }}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        handleSearch()
                      }
                    }}
                    id="search-bar-0"
                    type="text"
                    className="form-control"
                    placeholder={"Search Product Code..."}
                    value={searchText}
                  />
                </div>

                <div className="col-md-4 px-0">
                  <div className="row">
                    <div className={`${isMobile ? 'serchButtonStyle' : ''} col-md-6`} style={{ paddingRight: "0px" }}>
                      {IsLoading ? (
                        <button type="button" className="btn btn-primary">
                          <i className="bx bx-hourglass bx-spin font-size-13 align-middle me-1"></i>
                          Loading
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-primary "
                          onClick={() => {
                            handleSearch()
                          }}
                        >
                          <i className="bx bx-search-alt font-size-16 align-middle me-2"></i>
                          Search
                        </button>
                      )}
                    </div>
                    <div
                      className={`${isMobile ? 'pendingReturnStyle' : ''} gap-3 col-md-5 px-0 d-flex align-items-center text-nowrap`}
                      style={{ paddingLeft: "0px" }}
                    >
                      <FormGroup check>
                        <Input
                          id="checkbox2"
                          type="checkbox"
                          defaultChecked={pendingForReturn}
                          onChange={e => setpendingForReturn(e.target.checked)}
                        />
                        <Label for="checkbox2" check>
                          Return Pending
                        </Label>
                      </FormGroup>
                      <FormGroup check>
                        <Input
                          id="checkbox"
                          type="checkbox"
                          defaultChecked={isAllData}
                          onChange={e => setIsAllData(e.target.checked)}
                        />
                        <Label for="checkbox" check>
                          All Data
                        </Label>
                      </FormGroup>
                    </div>
                  </div>
                </div>
                {viewtotaliBooking ? (
                  <div
                    className={`${isMobile ? 'totalBoking' : ''} col-md-5 d-flex align-items-center justify-content-end text-end`}
                    style={{ color: "#0F6E25", fontSize: "15px" }}
                  >
                    Total {totalBooking} Bookings for
                    {` ${productDetails?.ProductName || ''}`}
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="row">
                <div className="col-md-10">
                  <ProductHistoryTable
                    columns={financeAmountShowHide ? columns : columns1}
                    data={tableData}
                    isGlobalFilter={false}
                    isCreateBooking={false}
                    customPageSize={1000}
                    IsLoading={IsLoading}
                    className="custom-header-css"
                  />
                </div>
                <div className="col-md-2 ">
                  <div>
                    <div>
                      <div
                        style={{
                          width: "150px",
                          height: "170px",
                          border: "1px solid #ced4da",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "3px",
                        }}
                      >
                        <img
                          className="img-fluid"
                          style={{
                            width: "140px",
                            height: "160px",
                          }}
                          src={
                            productDetails?.ProductImage
                              ? productDetails?.ProductImage
                              : uploadImage
                          }
                        />
                      </div>
                      <div style={{ display: "flex", gap: "15px", justifyContent: "center" }}>
                        <div>
                          {
                            (productDetails?.IsSale == true) && (
                              <div className="mt-2 text-center " style={{ fontSize: "14px" }}>
                                <span style={{ fontWeight: "600", color: "#dd3939" }}>Sale</span>
                              </div>
                            )
                          }
                          {
                            (productDetails?.IsRetire == true && productDetails?.IsSale == false) && (
                              <div className="mt-2 text-center " style={{ fontSize: "14px" }}>
                                <span style={{ fontWeight: "600", color: "#dd3939" }}>Retire</span>
                              </div>
                            )
                          }
                        </div>
                        <div>
                          {
                            (productDetails?.IsWashing == true) && (
                              <div className="mt-2 text-center " style={{ fontSize: "14px" }}>
                                <span style={{ fontWeight: "600" }}>Washing</span>
                              </div>
                            )
                          }
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="mt-1 " style={{ fontSize: "15px" }}>
                        <div>
                          <span style={{ fontWeight: "600" }}> Name:</span> {productDetails?.ProductName ? productDetails?.ProductName : "N/A"}
                        </div>

                        <div className="mt-1">
                          <span style={{ fontWeight: "600" }}> Code:</span> {productDetails?.ProductCode ? productDetails?.ProductCode : "N/A"}
                        </div>
                        {financeAmountShowHide &&
                          <>
                            <div className="mt-1">
                              <span style={{ fontWeight: "600" }}> MRP: </span>
                              <i className="mdi mdi-currency-inr"></i>
                              {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                              }).format(productDetails?.MRP
                                || 0)}
                            </div>
                          </>}
                        <div className="mt-1">
                          <span style={{ fontWeight: "600" }}> Rent: </span>
                          <i className="mdi mdi-currency-inr"></i>
                          {new Intl.NumberFormat('en-IN', {
                            currency: 'INR',
                            minimumFractionDigits: 2,
                          }).format(productDetails?.Rent
                            || 0)}
                        </div>
                        <div className="mt-1">
                          <span style={{ fontWeight: "600" }}>Color:</span> {productDetails?.ColorName ? productDetails?.ColorName : "N/A"}
                        </div>

                        <div className="mt-1">
                          <span style={{ fontWeight: "600" }}>Size: </span> {productDetails?.SizeName ? productDetails?.SizeName : "N/A"}
                        </div>
                        {financeAmountShowHide &&
                          <div className="mt-1">
                            <span style={{ fontWeight: "600" }}>Earned: </span>  <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            }).format(totalEarned
                              || 0)}
                          </div>
                        }
                      </div>
                      {/* {viewtotaliBooking &&
                        <div className="mt-2">
                          <Button
                            color="primary"
                            className="btn btn-primary btn-sm"
                            type="button"
                            style={{ width: "100%" }}
                            onClick={() => handleProductHistory(productDetails?.ProductCode)}
                          >
                            <i className=" fs-6  bx bx-detail" style={{ marginRight: "3px", marginTop: "3px", padding: "2px" }}></i>
                            <span style={{ fontSize: "13px" }}>Go to Detail</span>
                          </Button>
                        </div>
                      } */}
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ProductHistory
